import { Component, OnInit, Input, Output, EventEmitter, Pipe, PipeTransform, HostListener, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ChangeDetectorRef, Inject } from '@angular/core';
import { APIService } from './../api.service';
import { AccountsComponent } from '../accounts/accounts.component';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { formatDate, DatePipe, DOCUMENT } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { FormControl } from '@angular/forms';
import { CommonService } from './../services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SetAcctStartDateComponent } from '../set-acct-start-date/set-acct-start-date.component';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

export enum KEY_CODE {
    UP_ARROW = 38,
    DOWN_ARROW = 40,
    RIGHT_ARROW = 39,
    LEFT_ARROW = 37,
    ALT = 18,
    CTRL = 17,
    S = 83
}


//import { LedgerRecordComponent } from '../ledger-record/ledger-record.component';

//import {
//    ChangeDetectionStrategy,
//    ChangeDetectorRef,
//    Component,
//    Inject,
//    OnDestroy
//} from '@angular/core';
//import {MatCalendar} from '@angular/material/datepicker';
//import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
//import {Subject} from 'rxjs';
//import {takeUntil} from 'rxjs/operators';



@Component({
    selector: 'app-voucher-entry',
    templateUrl: './voucher-entry.component.html',
    styleUrls: ['./voucher-entry.component.scss']
})


export class VoucherEntryComponent {

   // @Input() public voucherID: any;
    @Input() public mdlRefHide: any;
    @Input() public EffectiveDate: any;
    @Input() mdlRef: any;
    @ViewChild('ledgerEntry') ledgerEntryMdl!: ElementRef;

    @Output() oncloseVchrModal: EventEmitter<any> = new EventEmitter<any>();
    jarvisData: any = [];
    modalReference: any;
    agencyData: any = [];
    headData: any = [];
    ledgerData: any = [];
    voucherID: any = this.commonService.GetParam('voucherID')
    Date = new Date();
    window: any = "";
    // curDate: any = new Date();
    // month = this.curDate.getMonth() + 1;
    // year = this.curDate.getFullYear();
    // lastMonth: any = new Date(new Date().getFullYear(), new Date().getMonth() + 0, 1);
    // startDate = new Date(this.lastMonth);
    maxDate = new Date();
    minDate = new Date();
    tmpERPAgn: any = [];

    constructor(private modalService: NgbModal, private ref: ChangeDetectorRef, private apiService: APIService,
        private http: HttpClient, private dateAdapter: DateAdapter<Date>, public commonService: CommonService, private SpinnerLoader: NgxSpinnerService,
        @Inject(DOCUMENT) private document: Document) {
        this.dateAdapter.setLocale('en-IN');
        this.window = this.document.defaultView;
    }


    closeResult: any;
    dataTbl: any = [];
    customers: any = [];
    connections: any = [];
    suppliers: any = [];
    resp: any = {};
    voucherHistoryData: any = [];

    pipe = new DatePipe('en-US');
    now = Date.now();
    // fromDate: Date = new Date("2021-Apr-01");
    // toDate: Date = new Date("2022-Mar-31");
    data: any = {
        voucherType: '',
        voucherTypeID: '0',
        voucherNO: '',
        voucherDate: this.Date,
        ledgerID: '',
        ledgerName: '',
        credit: '0',
        debit: '0',
        curBal: '0',
        notes: '',
        details: '',
        imbalance: 0,
        voucherID: 0,
        curBalType: 'Db',
        payMode: 0,
        payRef: "",
        isPayment: false,
        isPaymentShow: false,
        voucherFile: "",
        previouNo: '',
        isUpdateRecAmt: false,
        isUpdateinvStatus: false,
        recAmt: '',
        relID: 0,
        isSavePaymentReceipt: false,
        partyName: '',
        dbVoucherFile: ''
    }

    lastVoucherNoList: any = [];

    type = [
        {
            id: 1,
            name: 'Bank Payment'
        },
        {
            id: 2,
            name: 'Bank Receipt'
        },
        {
            id: 3,
            name: 'Cash Payment'
        },
        {
            id: 4,
            name: 'Cash Receipt'
        },
        {
            id: 5,
            name: 'Journal Voucher'
        },
        {
            id: 6,
            name: 'Purchase Voucher'
        },
        {
            id: 7,
            name: 'Sale Voucher'
        },
        {
            id: 8,
            name: 'Contra Entry'
        },
        {
            id: 9,
            name: 'Salary'
        }
    ]

    ledgers: any = [];

    editDataList: any = [];
    newledgerEntryData: Array<any> = [];
    showPrintReceiptBtn: boolean = false;

    //fileToUpload: File = null;
    fileToUpload: any;

    fileUpload: any = {
        val: ""
    }

    fileData: any;
    fileName: any;
    isEdit: boolean = false;
    docDetails: any = {
        DocID: 0,
        DocType: '',
        DocName: '',
        DocNo: ''
    }
    right: any;
    oldVoucherDT: any = '';
    custLdrCnt: number = 0;
    isShowUpdateRecovery: boolean = false;
    isWeb: boolean = true;
    showLearningMaterial: boolean = false;
    showOnBoarding: boolean = false;

    compRules = {
        isB2C: false
      };

    rcvdAmt: number = 0;
    

  ngOnInit(): void {

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if (this.right) {
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function (o: any) { return o.UserID == ownUserID })[0];
      if (!this.right.AcctsVchrEntry && !this.right.AcctsVchrEdit) {
        this.closeEntryModal(false);
        this.window.close();
      }
    }
    else{
      this.closeEntryModal(false);
      this.window.close();
      return;
    }

    if(this.voucherID > 0 && !this.right.AcctsVchrEdit){
        this.closeEntryModal(false);
        this.window.close();
    }

        if (this.EffectiveDate) {
            this.data.voucherDate = this.EffectiveDate;
        }

        let agencyData = this.apiService.getCookie("M");
        if (agencyData) {
            this.agencyData = JSON.parse(agencyData);
            this.compRules.isB2C = this.agencyData[0].IsB2C;
        }

        

        let prevAgencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
        if (prevAgencyConfig) {
            let finalConf: any = prevAgencyConfig;
            finalConf = JSON.parse(prevAgencyConfig);
            if (finalConf.length > 0) {
                let lastVocherList = finalConf[0].LastVchrNos;
                if (lastVocherList) {
                    this.lastVoucherNoList = JSON.parse(lastVocherList);
                }
            }
        }


        let head = this.apiService.getCookie("Heads");
        if (head) {
            this.headData = JSON.parse(head);
        }

        let ledger = this.apiService.getCookie("Ledger");
        if (ledger) {
            this.ledgerData = JSON.parse(ledger);
        }

        let tmpERPAgn = this.apiService.getCookie("ERP_Agn");
        if (tmpERPAgn) {
            this.tmpERPAgn = JSON.parse(tmpERPAgn);
            if (this.tmpERPAgn && this.tmpERPAgn.length > 0) {
                this.minDate = new Date(this.tmpERPAgn[0].AccountStartDT);
            }
        }

        // this.oldVoucherDT = this.oldVoucherDT ? this.oldVoucherDT : new Date();
        // let currentFinYear: any = this.commonService.getCurrentFinancialYear(this.oldVoucherDT);
        // let finfirstDT = new Date('1-Apr' + String(currentFinYear).split('-')[0]);
        // let finastdt = new Date('31-Mar' + String(currentFinYear).split('-')[1]);
        // this.fromDate  = finfirstDT;
        // this.toDate = finastdt;

        this.isWeb = this.apiService.apiCheckWeb();
        this.showLearningMaterial = this.commonService.checkShowLearningMaterial();
        this.showOnBoarding = this.commonService.checkShowOnBoarding();
        this.getData();
    }

    // @HostListener('window:keyup', ['$event'])
    // keyEvent(event: KeyboardEvent) {
        
    //     if (event.keyCode == KEY_CODE.CTRL && KEY_CODE.S) {
    //         // Your row selection code
    //       alert();
    //     }
    // }

    // Window short cut key
    @HostListener('window:keydown.alt.s', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        this.save();
    }

    //getData()
    getData() {
        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'initEntry',
            moduleID: 0,
            data: ''
        }];
        this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));

        //Get H from IDB
        var self = this;
        let hCook = this.apiService.getIDB('H', function(data: any){
            if(data){
                self.connections = data;
            }
        })
    }

    //getEditData()
    getEditData() {

        var tempData = [{
            'voucherID': this.voucherID
        }]
        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'initEdit',
            moduleID: 0,
            data: JSON.stringify(tempData)
        }];
        this.apiService.getData(myParams, this.successEditResp.bind(this), this.failureResp.bind(this));
    }

    //save - save voucher
    save() {
        // var jarvis = this.apiService.getCookie("Jarvis");
        // if (jarvis == 'undefined' || jarvis == undefined || jarvis == null) {
        //     window.location.href = '../../main.html#/home';
        //   }
        
        let isValid = this.commonService.checkLogin();
        if (!isValid) {
            return;
        }
        //Validation
        if (this.data.voucherTypeID == "0") {
            this.apiService.successAlert("Please select voucher type.");
            //alert('Please select voucher type.');
            return;
        }

        else if (this.data.voucherNO == "") {
            this.apiService.successAlert('Please enter voucher no.');
            return;
        }

        else if (this.data.voucherDate == "") {
            this.apiService.successAlert('Please select voucher date.');
            return;
        }

        else if (this.dataTbl.length == 0) {
            this.apiService.successAlert('Please enter voucher details.');
            return;
        }
        else if(this.data.isSavePaymentReceipt == true && !this.data.partyName){
            this.apiService.successAlert("Please enter payer party name.");
            return;
        }    
        else {
            var creditData: any = [];
            var debitData: any = [];
            var creditSum = 0;
            var debitSum = 0;
            var creditList: any = [];
            var debitList: any = [];

            creditList = this.dataTbl.filter(function (element: any, index: any) {
                return (element.credit > 0);
            });

            debitList = this.dataTbl.filter(function (element: any, index: any) {
                return (element.debit > 0);
            });

            for (var j = 0; j < creditList.length; j++) {
                creditSum = this.roundToTwo(Number(creditSum) + Number(creditList[j].credit));
            }

            if (creditSum == 0) {
                this.apiService.successAlert('Please enter non-zero amount for credit.');
                return;
            }

            for (var j = 0; j < debitList.length; j++) {
                debitSum = this.roundToTwo(Number(debitSum) + Number(debitList[j].debit));
            }

            if (debitSum == 0) {
                this.apiService.successAlert('Please enter non-zero amount for debit.');
                return;
            }

            if (creditSum != debitSum) {
                alert('Voucher imbalance!');
                return;
            }
            else {
                for (var i = 0; i < creditList.length; i++) {
                    creditData.push({
                        LedgerID: creditList[i].ledgerID,
                        Amount: creditList[i].credit + "",
                        Notes: creditList[i].notes
                    });
                }

                for (var i = 0; i < debitList.length; i++) {
                    debitData.push({
                        LedgerID: debitList[i].ledgerID,
                        Amount: debitList[i].debit + "",
                        Notes: debitList[i].notes
                    });
                }
                if(this.fileName){
                    this.uploadSEFileNew((obj: boolean) => {
                        if(obj == true){
                            this.fileName = this.data.voucherFile;
                            this.fn_newVoucher(creditData, debitData);
                        };                        
                    });
                }
                else{
                    this.fileName = "";
                    this.fn_newVoucher(creditData, debitData);
                }
            }
        }
    }

    //fn_newVoucher() - New Vooucher Entry
    fn_newVoucher(creditData: any, debitData: any){
        console.log("New File", this.fileName);
        let attechLink = "";

        if(this.data.voucherTypeID != 2 && this.data.voucherTypeID != 4){
            this.data.isSavePaymentReceipt = false;
            this.data.partyName = "";
        }

        if (this.fileName) {
            attechLink = "Uploads/Vouchers/" + this.data.voucherFile;
        }
        else {
            if (this.data.voucherID > 0) {
                attechLink = this.data.dbVoucherFile ? this.data.dbVoucherFile : '';
            }
            else {
                attechLink = "";
            }
        }

        var tempData = [{
            'voucherNum': this.data.voucherNO,
            'effectiveDate': new Date(this.data.voucherDate).customFormat("#DD#-#MMM#-#YY#"),
            'note': this.data.details,
            'voucherType': this.data.voucherTypeID,
            'voucherID': this.data.voucherID,
            'creditData': JSON.stringify(creditData),
            'debitData': JSON.stringify(debitData),
            'payMode': this.data.payMode,
            'payRef': this.data.payRef,
            'mainLedgerID': 0,
            'mainLedger': "",
            'voucherFile': attechLink,
            'isUpdateRecovery': this.data.isUpdateRecAmt ? this.data.isUpdateRecAmt : false,
            'recoveryAmt': this.data.isUpdateRecAmt ? this.data.recAmt : 0,
            'relID': this.data.relID ? this.data.relID : 0,
            'PayerPartyName': (this.data.isSavePaymentReceipt == true ? this.data.partyName : '')
        }];

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'set',
            moduleID: 0,
            data: JSON.stringify(tempData)
        }];
        this.SpinnerLoader.show();
        this.apiService.sendChange(myParams, this.successVchrEntry.bind(this), this.failureResp.bind(this));
    }

    //successVchrEntry - success voucher entry handler
    successVchrEntry(res: any) {
        this.SpinnerLoader.hide();
        if (res.error) {
        }
        else {
            let isSuccessEntry: boolean = true;
            let relID = (this.data.relID ? this.data.relID : 0);
            let isUpdateInvStatus = this.data.isUpdateinvStatus;
            let Rcvb = this.data.recAmt;
            let isUpdateRecovery = this.data.isUpdateRecAmt;
            let tmpData = JSON.parse(res.updatePackage).Table[0];     
            
            if((this.data.voucherTypeID == '2' || this.data.voucherTypeID == '4') && this.data.isSavePaymentReceipt == true){
                if(tmpData.VoucherID > 0 && tmpData.VoucherID != undefined){
                    window.open('paymentReceipt?VID=' + tmpData.VoucherID, '_blank','Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');  
                }
            }

            if (tmpData.ErrCode != -1) {
                isSuccessEntry = false;
                alert(tmpData.ErrMsg);                
                // return;
            }
            else {
                this.resetAllData();
                //alert(res.message);
                alert(!this.isEdit ? 'Voucher entered.' : 'Voucher updated.')
                this.closeEntryModal(true);
                // window.close();
            }

            let agencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
            if (agencyConfig) {
                agencyConfig = JSON.parse(agencyConfig);
                let fnllAgencyConfigData: any = [];
                fnllAgencyConfigData = agencyConfig;
                if (fnllAgencyConfigData.length > 0) {
                    fnllAgencyConfigData[0].LastVchrNos = tmpData.LastVchrNos;
                }
                this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(fnllAgencyConfigData));
            }
            else {
                let cookieData = [{
                    LastVchrNos: tmpData.LastVchrNos
                }];
                this.apiService.setCookie('Cfg_AgnCfg', JSON.stringify(cookieData));
            }
            this.voucherTypeChanged(this.data.voucherType);

            if(isSuccessEntry == true){
                if(isUpdateRecovery == true){
                     //Get H from IDB
                     var self = this;
                     let hCookie = this.apiService.getIDB('H', function(dataList: any){
                         if(dataList){ 
                             let tblH = dataList;
                             if(tblH.length > 0){
                                 let ind: number = tblH.map((e: any) => e.RI).indexOf(relID);
                                 if(ind > -1){
                                     tblH[ind].Rcvb = Rcvb;
                                     self.apiService.setIDB("H", tblH)
                                     // self.apiService.setCookie("H", JSON.stringify(tblH));
                                 }
                             }
                         }                       
                       })   
                    
                };

                let successDataEntry = [{
                    'relID': relID,
                    'isUpdateInvoice': isUpdateInvStatus
                }];

                this.window.isSuccessVoucher = 1;
                this.window.updateData = successDataEntry;
            }
        }
    }

    //failureResp - failure handler
    failureResp(res: any) {
        this.SpinnerLoader.hide();
        if (res.error) {
        }
        else {
            alert(res.message);
        }
    }

    //successResp - success  get handler
    successResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData.Table1) {
                    this.ledgers = reponseData.Table1;
                    if(this.newledgerEntryData.length > 0){
                        let tmpCurrLedger: any = this.ledgers.filter((o: any) => o.Ledger == this.newledgerEntryData[0].LedgerName);
                        if (tmpCurrLedger.length > 0){
                            this.newledgerEntryData[0].LedgerID = tmpCurrLedger[0].LedgerID;
                            let tmpAllLedger = this.apiService.getCookie("Ledger");
                            let allLedger: Array<any> = [];
                            if(tmpAllLedger){
                                allLedger = JSON.parse(tmpAllLedger);
                                allLedger.push(this.newledgerEntryData[0]);
                                this.newledgerEntryData = [];
                                this.apiService.setCookie("Ledger", JSON.stringify(allLedger));
                            }
                        }
                    }
                    //this.ref.detach();
                    //setInterval(() => {
                    //    this.ref.detectChanges();
                    //}, 5000);
                }

                if (reponseData.Table2) {

                }

                if (this.voucherID && this.voucherID > 0) {
                    this.data.voucherID = this.voucherID;
                    this.isEdit = true;
                    this.getEditData();
                }
            }
        }
    }

    //successResp - success  get handler
    successEditResp(res: any) {
        if (res.error) {
        }
        else {
            if (res) {
                var reponseData = JSON.parse(res.updatePackage);
                if (reponseData.Table1[0]) {
                    let editDataArry = reponseData.Table1;
                    this.voucherHistoryData = reponseData.Table2;
                    let userData: any = this.apiService.getCookie("J");
                    if(userData){
                        userData = JSON.parse(userData);
                    }

                    this.voucherHistoryData.forEach((p: any) => {
                        let user = userData.filter((a: any) => { return a.UserID == p.CreatedUserID });
                        if(user.length > 0){
                            p.userName = user[0].Name;
                        }
                        p.CreatedDT = new Date(p.CreatedDT).customFormat('#DD#-#MMM#-#YY# @ #hh#:#mm# #AMPM#');
                    })
                    this.voucherHistoryData.sort((a:any, b:any) => new Date(b.CreatedDT).getTime() - new Date(a.CreatedDT).getTime());

                    this.editDataList = editDataArry;
                    this.dataTbl = [];
                    for (let i = 0; i < this.editDataList.length; i++) {
                        this.data.voucherNO = this.editDataList[i].VoucherNo;
                        this.data.voucherDate = this.editDataList[i].EffectiveDate;
                        this.data.details = this.editDataList[i].MainNotes;
                        this.data.voucherType = "";
                        this.data.voucherTypeID = this.editDataList[i].VoucherTypeID;
                        let tmpVchrId = this.data.voucherTypeID;
                        let tmpLedgerID: number = this.editDataList[i].LedgerID;

                        if(this.editDataList[i].PayerPartyName){
                            this.data.partyName = this.editDataList[i].PayerPartyName;
                            this.data.isSavePaymentReceipt = true;
                            this.showPrintReceiptBtn = true;
                        }

                        let tmpVoucherName = this.type.filter(function (element: any, index: any) {
                            return (element.id == tmpVchrId);
                        });
                        this.data.voucherType = tmpVoucherName[0].name;
                        var curBalType = "";
                        if (this.editDataList[i].CurrentBal < '0') {
                            this.editDataList[i].CurrentBal = 0 - (this.editDataList[i].CurrentBal);
                            curBalType = ' Cr';
                        }
                        else {
                            this.editDataList[i].CurrentBal = this.editDataList[i].CurrentBal;
                            curBalType = ' Db'
                        }

                        let tmpLedgers: Array<any> = this.ledgers.filter(function (e: any, ind: number) {
                            return (e.LedgerID == tmpLedgerID);
                        });

                        if (tmpLedgers.length == 0) {
                            for (let j = 0; j < this.editDataList.length; j++)
                                this.editDataList[j].IsBank = false;
                        } else {
                            for (let j = 0; j < this.editDataList.length; j++) {
                                this.editDataList[j].IsBank = tmpLedgers[0].IsBank;
                            }


                        }

                        // for (let j = 0; j < this.editDataList.length; j++) {
                        //     if (!this.editDataList[j].IsBank) {
                        //         this.editDataList[j].IsBank = false;
                        //         this.data.isPaymentShow = false;
                        //     }
                        // }

                        // for (let j = 0; j < this.editDataList.length; j++) {
                        //     if (this.editDataList[j].PaymentMode != 0) {
                        //         this.data.isPaymentShow = true;
                        //         this.data.payMode = this.editDataList[0].PaymentMode;
                        //         this.data.payRef = this.editDataList[0].PaymentRef;
                        //     }
                        // }

                        let isAllowDecimalCR: boolean = false;
                        let crArr: Array<any> = String(this.editDataList[i].CreditAmount).split(".");
                        if(crArr.length > 1)   {
                            isAllowDecimalCR = true;
                        }

                        let isAllowDecimalDB: boolean = false;
                        let dbArr: Array<any> = String(this.editDataList[i].DebitAmount).split(".");
                        if(dbArr.length > 1)   {
                            isAllowDecimalDB = true;
                        }
                        
                        // this.dataTbl.push({
                        //     'ledgerID': this.editDataList[i].LedgerID,
                        //     'ledgerName': this.editDataList[i].Ledger,
                        //     'credit': isAllowDecimalCR ? Number(this.editDataList[i].CreditAmount).toFixed(2) : this.editDataList[i].CreditAmount,
                        //     'debit': isAllowDecimalDB ? Number(this.editDataList[i].DebitAmount).toFixed(2) : this.editDataList[i].DebitAmount,
                        //     'notes': this.editDataList[i].ItemNotes,
                        //     'curBal': this.editDataList[i].CurrentBal,
                        //     'curBalType': curBalType,
                        //     'IsBank': this.editDataList[i].IsBank
                        // });

                        this.dataTbl.push({
                            'ledgerID': this.editDataList[i].LedgerID,
                            'ledgerName': this.editDataList[i].Ledger,
                            'credit': Number(this.editDataList[i].CreditAmount).toFixed(2),
                            'debit': Number(this.editDataList[i].DebitAmount).toFixed(2),
                            'notes': this.editDataList[i].ItemNotes,
                            'curBal': this.editDataList[i].CurrentBal,
                            'curBalType': curBalType,
                            'IsBank': this.editDataList[i].IsBank
                        });
                    }

                    console.log("Voucher Edit", this.editDataList);
                    if(this.editDataList[0].DocInvoiceID > 0){
                        // if(this.editDataList[0].DocType != 'DSPLINV'){
                            this.docDetails.DocID = this.editDataList[0].DocInvoiceID;                        
                            this.docDetails.DocType = this.editDataList[0].DocType;
                            this.docDetails.DocName = (this.editDataList[0].DocType == 'DINV' ? 'Invoice' : (this.editDataList[0].DocType == 'DSPLINV' ? 'Supplier Invoice' : (this.editDataList[0].DocType == 'DCRN' ? 'Credit Note' :  (this.editDataList[0].DocType == 'DDBN' ? 'Debit Note' : ''))));
                            this.docDetails.DocNo = this.editDataList[0].DocNo;
                        // }
                        // else{
                        //     this.docDetails.DocID = 0;
                        //     this.docDetails.DocType = '';
                        //     this.docDetails.DocName = '';
                        //     this.docDetails.DocNo = '';
                        // }
                    }

                    console.log(this.dataTbl)
                    var isBankData = this.dataTbl.filter(function (element: any, index: any) {
                        return (element.IsBank == true);
                    });
                    if (isBankData.length > 0) {
                        this.data.isPaymentShow = true;
                        this.data.payMode = this.editDataList[0].PaymentMode;
                        this.data.payRef = this.editDataList[0].PaymentRef;
                    }
                    else {
                        this.data.isPaymentShow = false;
                    }

                    this.data.dbVoucherFile = this.editDataList[0].VoucherFile ? this.editDataList[0].VoucherFile : '';
                }
            }
        }
    }

    //resetData - reset form data
    resetData() {
        this.data.ledgerID = '0';
        this.data.ledgerName = '';
        this.data.credit = '0';
        this.data.debit = '0';
        this.data.curBal = '0';
        this.data.notes = '';
        this.data.isPayment = false;
    }

    //resetAllData
    resetAllData() {
        this.data.voucherType = '';
        this.data.voucherTypeID = '0';
        this.data.voucherNO = '';
        this.data.details = '';
        this.data.imbalance = '0';
        this.data.voucherDate = this.pipe.transform(this.now, 'dd-MMM-yy'),
            this.data.ledgerID = '0';
        this.data.ledgerName = '';
        this.data.credit = '0';
        this.data.debit = '0';
        this.data.curBal = '0';
        this.data.notes = '';
        this.dataTbl = [];
        this.data.isPayment = false;
        this.data.isPaymentShow = false;
        this.data.isUpdateRecAmt = false;
        this.data.isUpdateinvStatus = false;
        this.data.recAmt = '';
        this.data.relID = 0;
        this.data.isSavePaymentReceipt = false;
        this.data.partyName = '';
    }

    //ledgerChng
    ledgerChng(ledgerName: any, ind: number) {
        var ledgerData = this.ledgers.filter(function (element: any, index: any) {
            return (element.Ledger == ledgerName);
        });

        // if (ledgerData.length == 0) {
        //     alert("Please enter valid voucher.");
        //     this.dataTbl[ind].ledgerName = '';
        // }
        if (ledgerData.length > 0) {
            if (this.isEdit == false) {
                if (ind == -1) {
                    if (ledgerData[0].CurrentBal < '0') {
                        this.data.curBal = 0 - Number(ledgerData[0].CurrentBal);
                        this.data.curBalType = ' Cr';
                    }
                    else {
                        this.data.curBal = ledgerData[0].CurrentBal;
                        this.data.curBalType = ' Db'
                    }

                    this.data.ledgerName = ledgerData[0].Ledger;
                    this.data.ledgerID = ledgerData[0].LedgerID + '';
                }
                else if (ind != -1) {
                    this.dataTbl[ind].ledgerID = ledgerData[0].LedgerID + '';
                    if (ledgerData[0].CurrentBal < '0') {
                        this.dataTbl[ind].curBal = 0 - Number(ledgerData[0].CurrentBal);
                        this.dataTbl[ind].curBalType = ' Cr';
                    }
                    else {
                        this.dataTbl[ind].curBal = ledgerData[0].CurrentBal;
                        this.dataTbl[ind].curBalType = ' Db'
                    }
                }
            }
            else if (this.isEdit == true) {
                if (ind == -1) {
                    if (ledgerData[0].CurrentBal < '0') {
                        this.data.curBal = 0 - Number(ledgerData[0].CurrentBal);
                        this.data.curBalType = ' Cr';
                    }
                    else {
                        this.data.curBal = ledgerData[0].CurrentBal;
                        this.data.curBalType = ' Db'
                    }

                    this.data.ledgerName = ledgerData[0].Ledger;
                    this.data.ledgerID = ledgerData[0].LedgerID + '';
                }
                else {
                    this.dataTbl[ind].ledgerID = Number(ledgerData[0].LedgerID);
                    this.dataTbl[ind].IsBank = ledgerData[0].IsBank;

                    if (ledgerData[0].CurrentBal < '0') {
                        this.dataTbl[ind].curBal = 0 - Number(ledgerData[0].CurrentBal);
                        this.dataTbl[ind].curBalType = ' Cr';
                    }
                    else {
                        this.dataTbl[ind].curBal = ledgerData[0].CurrentBal;
                        this.dataTbl[ind].curBalType = ' Db'
                    }
                }

            }

            let isBank: boolean = false;
            for (let i = 0; i < this.dataTbl.length; i++) {
                if (this.dataTbl[i].IsBank == true) {
                    isBank = true;
                    break;
                }
            };

            if (isBank == true) {
                this.data.isPaymentShow = true;
                this.data.isPayment = true
            }
            else {
                if (ledgerData[0].IsBank) {
                    this.data.isPaymentShow = true;
                    this.data.isPayment = true;
                }
                else {
                    this.data.isPaymentShow = false;
                    this.data.isPayment = false;
                }

            }
        }
    }

    changeCrDbVal(ind: number, type: string) {
        if (this.dataTbl[ind].credit > 0 && type == 'C') {
            this.dataTbl[ind].debit = 0;
        }
        else if (this.dataTbl[ind].debit > 0 && type == 'D') {
            this.dataTbl[ind].credit = 0;
        }

        var creditListData = this.dataTbl.filter(function (element: any, index: any) {
            return (element.credit > 0);
        });

        var debitListData = this.dataTbl.filter(function (element: any, index: any) {
            return (element.debit > 0);
        });

        var creditSum = 0;
        var debitSum = 0;

        for (var j = 0; j < creditListData.length; j++) {
            creditSum = this.roundToTwo(Number(creditSum)) + this.roundToTwo(Number(creditListData[j].credit));
        }

        for (var j = 0; j < debitListData.length; j++) {
            debitSum = this.roundToTwo(Number(debitSum)) + this.roundToTwo(Number(debitListData[j].debit));
        }
        
        this.dataTbl[ind].debit = Number(this.dataTbl[ind].debit).toFixed(2);
        this.dataTbl[ind].credit = Number(this.dataTbl[ind].credit).toFixed(2);
        this.data.imbalance = Number(debitSum) - Number(creditSum);

        this.custLdrCnt = 0;
        this.data.recAmt = 0;            
        for(let i: number = 0; i < this.dataTbl.length; i++){
            if(this.dataTbl[i].credit > 0){
                let selectedLdr: any = this.ledgers.filter((o: any) => o.IsCustomer == true && o.LedgerID == this.dataTbl[i].ledgerID);
                if(selectedLdr.length > 0){
                    this.custLdrCnt = this.custLdrCnt + 1;
                    if(this.custLdrCnt == 1){
                        this.isShowUpdateRecovery = true;
                        this.data.isUpdateRecAmt = false;
                        this.data.relID = selectedLdr[0].RelID;

                        /* let cloVal: number = Number(String(selectedLdr[0].CurrentBal).replaceAll(",", ""));
                        this.data.recAmt =  cloVal - Number(this.dataTbl[i].credit);
                        if(this.data.recAmt < 0){
                            this.data.recAmt = 0;
                        } */
                    }
                    else{
                        this.data.isUpdateRecAmt = false;
                        this.isShowUpdateRecovery = false;
                        this.data.recAmt = 0;
                        this.data.relID = 0;
                    }
                }
            }
        }
    }

    //onBlurEvent - on credir debit
    onBlurEvent(event: any, obj: any) {
        if (obj.debit != 0) {
            obj.credit = 0.00;
        }

        if (obj.credit != 0) {
            obj.debit = 0.00;
        }

        if ((obj.credit != 0 || obj.debit != 0) && obj.ledgerID > 0) {
            this.dataTbl.push({
                'ledgerID': obj.ledgerID,
                'ledgerName': obj.ledgerName,
                'credit': Number(obj.credit).toFixed(2),
                'debit': Number(obj.debit).toFixed(2),
                'notes': obj.notes,
                'curBal': obj.curBal,
                'curBalType': obj.curBalType,
                'IsBank': obj.isPayment
            });
            this.resetData();
            setTimeout(() => {
                $('#notes' + (this.dataTbl.length - 1)).focus();
            }, 50);

        }

        var creditSum = 0;
        var debitSum = 0;

        var creditListData = this.dataTbl.filter(function (element: any, index: any) {
            return (element.credit > 0);
        });

        var debitListData = this.dataTbl.filter(function (element: any, index: any) {
            return (element.debit > 0);
        });


        for (var j = 0; j < creditListData.length; j++) {
            creditSum = this.roundToTwo(Number(creditSum)) + this.roundToTwo(Number(creditListData[j].credit));
        }

        for (var j = 0; j < debitListData.length; j++) {
            debitSum = this.roundToTwo(Number(debitSum)) + this.roundToTwo(Number(debitListData[j].debit));
        }

        this.data.imbalance = Number(this.roundToTwo(debitSum)) - Number(this.roundToTwo(creditSum));
        // if (this.data.imbalance < 0) {
        //     this.data.imbalance = 0 - Number(this.data.imbalance) + ' Db';
        // }
        // else {
        //     this.data.imbalance = Number(this.data.imbalance) + ' Cr';
        // }

        // var isBankData = this.dataTbl.filter(function (element: any, index: any) {
        //     return (element.IsBank == true);
        // });

        // if (isBankData.length > 0) {
        //     this.data.isPaymentShow = true;
        // }
        // else {
        //     this.data.isPaymentShow = false;
        // }

        let isBank: boolean = false;
        for (let i = 0; i < this.dataTbl.length; i++) {
            if (this.dataTbl[i].IsBank == true) {
                isBank = true;
                break;
            };
        };

        if (isBank == true) {
            this.data.isPaymentShow = true;
        }
        else {
            this.data.isPaymentShow = false;
        }       
        
        this.custLdrCnt = 0;
        this.data.recAmt = 0;            
        for(let i: number = 0; i < this.dataTbl.length; i++){
            if(this.dataTbl[i].credit > 0){
                let selectedLdr: any = this.ledgers.filter((o: any) => o.IsCustomer == true && o.LedgerID == this.dataTbl[i].ledgerID);
                if(selectedLdr.length > 0){
                    this.custLdrCnt = this.custLdrCnt + 1;
                    if(this.custLdrCnt == 1){
                        this.isShowUpdateRecovery = true;
                        this.data.isUpdateRecAmt = false;
                        this.data.relID = selectedLdr[0].RelID;
                        /*let cloVal: number = Number(String(selectedLdr[0].CurrentBal).replaceAll(",", ""));
                        this.data.recAmt =  cloVal - Number(this.dataTbl[i].credit);
                        if(this.data.recAmt < 0){
                            this.data.recAmt = 0;
                        }*/
                    }
                    else{
                        this.data.isUpdateRecAmt = false;
                        this.isShowUpdateRecovery = false;
                        this.data.recAmt = 0;
                        this.data.relID = 0;
                    }
                }
            }
        }
    }

    //numberOnly
    numberOnly(event: any): boolean {
        return this.commonService.numberOnly(event);
    }

    //
    numberOnlyPaste(event: ClipboardEvent): boolean {
        let pastedText: any = "";
        if (event.clipboardData) {
            pastedText = event.clipboardData.getData('text')
        }

        if (isNaN(pastedText) == true) {
            return false;
        }
        else {
            return true;
        }


    }

    //closeEntryModal
    closeEntryModal(isSuccess: boolean) {

        if (this.mdlRefHide) {
            this.mdlRefHide.close(isSuccess);
        }
        let isDone = isSuccess;
        if (this.voucherID && this.voucherID > 0) {
            this.oncloseVchrModal.emit(isDone);
            this.getData();
        }
        else {
            this.oncloseVchrModal.emit(isDone);
        }

        this.oncloseVchrModal.closed = true;
    }
    
    // openAskAcctStartDT() - Open modal for setting account start date.
	openAskAcctStartDT() {
		this.modalReference = this.modalService.open(SetAcctStartDateComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'acct-start-date-mdl', backdrop: 'static', keyboard: false });
		this.modalReference.componentInstance.setAcctDTModalRef = this.modalReference;
        this.modalReference.result.then((result: any) => {
            if (result == 'success') {
                this.openLedgerModal(this.ledgerEntryMdl, true);
            }
		    this.closeResult = `Closed with: ${result}`;
		}, (reason: any) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

    //File Upload Region
    handleFileInput(files: FileList) {
        this.fileToUpload = files.item(0);
        let file: File = files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            this.fileData = reader.result;
        };
        if (this.fileToUpload) {
            this.fileName = this.fileToUpload.name;
        }
    }

    //uploadSEFile(callBack: any) {
    //    let sPath = 'Vouchers/';
    //    var img = "";

    //    if (this.fileToUpload) {
    //        img = this.fileToUpload.name;
    //        this.fileName = img;
    //    }
    //    if (img != "") {
    //        var ServerPath = sPath;

    //        this.http.post('http://localhost:52301/WebService.asmx/UploadSFile', {
    //            data: this.fileData,
    //            path: typeof (img) != 'undefined' ? img : '',
    //            serverpath: sPath,
    //        }, httpOptions).subscribe(data => {
    //            //var temp = data;
    //            if ((data.d.error)) {
    //                alert("Please upload an image, .pdf or .zip file.");
    //                callBack(false, '');
    //                return false
    //                $('#addAttechment').val('');
    //            } else {
    //                callBack(true, data.d.message)
    //                return true;
    //            }
    //        });
    //    }
    //    else {
    //        callBack(true, '');
    //    }
    //}

    async uploadSEFileNew(callback: any) {
        let sPath = 'Vouchers/';
        var img = "";
        
        if (this.fileToUpload) {
            img = this.fileToUpload.name;
            this.fileName = img;
        }
        
        if (img != "") {
            // Use the new uploadSFileForm method
            this.apiService.uploadSFileForm(this.fileToUpload, img, sPath,
                (res: any) => {
                    // Success callback
                    this.data.voucherFile = res.message;
                    callback(true);
                },
                (error: any) => {
                    // Failure callback
                    alert("Please upload an image, .pdf or .zip file.");
                    $('#addAttechment').val('');
                    callback(false);
                }
            );
        }
    }

    addAttechmentFile() {
        $('#addAttechment').click();
    }

    removeAttechUploadedFile() {
        this.fileName = "";
        $('#addAttechment').val('');
        
        if (this.data.voucherID > 0) {
            this.data.dbVoucherFile = '';
        }
    }

    voucherTypeChanged(voucherTypeName: any) {
        let prevAgencyConfig = this.apiService.getCookie('Cfg_AgnCfg');
        if (prevAgencyConfig) {
            let finalConf: any = prevAgencyConfig;
            finalConf = JSON.parse(prevAgencyConfig);
            if (finalConf.length > 0) {
                let lastVocherList = finalConf[0].LastVchrNos;
                if (lastVocherList) {
                    this.lastVoucherNoList = JSON.parse(lastVocherList);
                }
            }
        }

        var voucherTypeDataList = this.type.filter(function (element: any, index: any) {
            return (element.name == voucherTypeName);
        });

        let a: any = this.commonService.getCurrentFinancialYear(this.data.voucherDate);
        let lastDate = new Date('31-Mar-' + String(a).split('-')[1]).customFormat('#YY#');

        if (voucherTypeDataList.length > 0) {
            this.data.voucherTypeID = voucherTypeDataList[0].id;
            if (this.lastVoucherNoList.length > 0) {
                for (let i = 0; i < this.lastVoucherNoList.length; i++) {
                    let tmpVchr = this.lastVoucherNoList[i].VTyp;
                    let a = tmpVchr.split('-')[1];
                    if (a == this.data.voucherTypeID && this.lastVoucherNoList[i].FY == lastDate) {
                        let lastNo = this.lastVoucherNoList[i].LastNo;
                        if (!isNaN(lastNo)) {
                            this.data.voucherNO = Number(lastNo) + 1;
                            this.data.previouNo = Number(lastNo);
                        }
                        else {
                            this.data.voucherNO = "";
                            this.data.previouNo = lastNo;
                        }
                        break;
                    }
                    else {
                        this.data.voucherNO = 1;
                        this.data.previouNo = '';
                    }
                }
            }
        }
        else {
            this.data.voucherTypeID = 0;
            this.data.voucherType = '';
        }

        if(this.data.voucherTypeID != 2 && this.data.voucherTypeID != 4){
            this.data.isSavePaymentReceipt = false;
            this.data.partyName = "";
        }
    }

    //vchrDTChange() - Voucher Date Change
    vchrDTChange(date: any) {
        let voucherTypeName: string = this.data.voucherType;
        var voucherTypeDataList = this.type.filter(function (element: any, index: any) {
            return (element.name == voucherTypeName);
        });

        this.oldVoucherDT = this.oldVoucherDT ? this.oldVoucherDT : new Date();
        let a: any = this.commonService.getCurrentFinancialYear(date._d);
        let lastDate = new Date('31-Mar-' + String(a).split('-')[1]).customFormat('#YY#');
        let isNotFound: boolean = true;

        let currentFinYear: any = this.commonService.getCurrentFinancialYear(this.oldVoucherDT);
        let currFinYear1stDT = new Date('1-Apr' + String(currentFinYear).split('-')[0]);
        let currFinYearEndtDT = new Date('31-Mar' + String(currentFinYear).split('-')[1]);

        if(currFinYear1stDT <= new Date(date._d) && currFinYearEndtDT >= new Date(date._d)){
            return;
        }

        if (voucherTypeDataList.length > 0) {
            this.data.voucherTypeID = voucherTypeDataList[0].id;
            if (this.lastVoucherNoList.length > 0) {
                for (let i = 0; i < this.lastVoucherNoList.length; i++) {
                    let tmpVchr = this.lastVoucherNoList[i].VTyp;
                    let a = tmpVchr.split('-')[1];
                    if (a == this.data.voucherTypeID && this.lastVoucherNoList[i].FY == lastDate) {
                        let lastNo = this.lastVoucherNoList[i].LastNo;
                        isNotFound = false;
                        if (!isNaN(lastNo)) {
                            this.data.voucherNO = this.isEdit ? Number(lastNo) + 1 : '';
                            this.data.previouNo = lastNo;
                        }
                        else {
                            this.data.voucherNO = "";
                            this.data.previouNo = lastNo;
                        }
                        break;
                    }
                    else {
                        this.data.voucherNO = 1;
                        this.data.previouNo = '';
                    }
                }
                if(isNotFound == true){
                    this.data.voucherNO = 1;
                    this.data.previouNo = '';
                }
            }
        }
        else {
            this.data.voucherTypeID = 0;
            this.data.voucherType = '';
        }

        this.oldVoucherDT = date._d;
    }

    roundToTwo(num: any) {
        return +(Math.round(parseFloat(num + "e+2")) + "e-2");
    }

    openLedgerModal(content: any, ignoreAcctMdl: boolean = false) {

        if (!ignoreAcctMdl) {
            let enteredLedgers: Array<any> = $.grep(this.ledgerData, (x: any) => { return x.LedgerName != 'Profit & Loss A/c' })
    
            if (enteredLedgers.length == 0) {
                this.openAskAcctStartDT();
                return;
            }
        }

        //this.modalReference.close();
        this.customers = $.grep(this.connections, (e: any) => { return (e.C == true) });
        this.suppliers = $.grep(this.connections, (e: any) => { return (e.S == true) });

        this.resetNewLedger();
        // this.newLedger.accountHead = this.tree[this.tree.length - 1].headID;
        //this.isShowZeroBal = false;
        this.modalReference = this.modalService.open(content, { windowClass: "ledgerModalClass", backdrop: 'static', keyboard: false });
        $('#txtNewLedger').focus();
    }

    newLedger = {
        accountHead: '0',
        ledgerName: '',
        openingBal: 0,
        curr: 'Cr',
        id: 0,
        type: 0,
        isCustomer: false,
        customerId: 0,
        customerName: '',
        isSupplier: false,
        supplierId: 0,
        supplierName: '',
        isBank: false,
        isCash: false,
        isEmployee: false,
        none: true
    };

    bank = {
        name: '',
        branch: '',
        accNo: '',
        ifsc: '',
        bankID: 0
    };


    resetNewLedger() {

        this.newLedger = {
            accountHead: '0',
            ledgerName: '',
            openingBal: 0,
            curr: 'Cr',
            id: 0,
            type: 0,
            isCustomer: false,
            customerId: 0,
            customerName: '',
            isSupplier: false,
            supplierId: 0,
            supplierName: '',
            isBank: false,
            isCash: false,
            isEmployee: false,
            none: true
        };
    }

    ledgerType(id: any) {
        //Select ledger type in ledger Entry/Edit modal
        if (id == 0) {
            this.newLedger.isCustomer = false;
            this.newLedger.isSupplier = false;
            this.newLedger.isBank = false;
            this.newLedger.isCash = false;
            this.newLedger.isEmployee = false;
        } else {
            this.newLedger.customerId = 0;
            this.newLedger.supplierId = 0;

            this.newLedger.isCustomer = false;
            this.newLedger.isSupplier = false;
            this.newLedger.isBank = false;
            this.newLedger.isCash = false;
            this.newLedger.isEmployee = false;
            // this.newLedger.none = true    
        }

        this.newLedger.type = id;
        id == 1 ? this.newLedger.isCustomer = true : id == 2 ? this.newLedger.isSupplier = true : id == 3 ? this.newLedger.isBank = true : id == 4 ? this.newLedger.isCash = true : this.newLedger.isEmployee = true;
    }

    saveLedger() {
        let tmpLedger = $.grep(this.ledgerData, (e: any) => { return (e.LedgerName == this.newLedger.ledgerName) });

        if (this.newLedger.accountHead == '0') {
            alert('Please select group head.')
        }

        else if (this.newLedger.ledgerName == '') {
            alert('Please enter ledger name.')
        }

        else if (tmpLedger.length > 0) {
            alert('Duplicate ledger name found.');
        }

        else if (this.newLedger.isCustomer && this.newLedger.customerId == 0) {
            alert('Please select customer.');
        }

        else if (this.newLedger.isSupplier && this.newLedger.supplierId == 0) {
            alert('Please select supplier.');
        }

        else if (this.newLedger.isBank && (!this.bank.name)) {
            alert('Please enter a bank name.');
            return;
        }

        else if (this.newLedger.isBank && (!this.bank.branch)) {
            alert('Please enter a branch.');
            return;
        }

        else if (this.newLedger.isBank && (!this.bank.ifsc)) {
            alert('Please enter a IFSC code.');
            return;
        }

        else if (this.newLedger.isBank && (!this.bank.ifsc)) {
            alert('Please enter an account number.');
            return;
        }
        else {
            let head = $.grep(this.headData, (e: any) => { return (e.HeadID == Number(this.newLedger.accountHead)) });
            let cust = $.grep(this.customers, (e: any) => { return (e.RI == Number(this.newLedger.customerId)) });
            let supp = $.grep(this.suppliers, (e: any) => { return (e.RI == Number(this.newLedger.supplierId)) });
            let obj = [{
                ledgerName: this.newLedger.ledgerName,
                headID: head[0].HeadID,
                openingBal: this.newLedger.curr == 'Cr' ? '-' + this.newLedger.openingBal : this.newLedger.openingBal,
                userID: 0,
                isCustomer: this.newLedger.isCustomer,
                isSupplier: this.newLedger.isSupplier,
                isBank: this.newLedger.isBank,
                isCash: this.newLedger.isCash,
                isEmployee: this.newLedger.isEmployee,
                relID: this.newLedger.isCustomer ? cust[0].RI : this.newLedger.isSupplier ? supp[0].RI : 0,
                relAgencyID: this.newLedger.isCustomer ? cust[0].RAID : this.newLedger.isSupplier ? supp[0].RAID : 0,
                bankName: this.bank.name ? this.bank.name : '',
                branch: this.bank.branch ? this.bank.branch : '',
                IFSC: this.bank.ifsc ? this.bank.ifsc : '',
                accountNo: this.bank.accNo ? this.bank.accNo : ''
            }];

            this.newledgerEntryData.push({
                LedgerID: 0,
                LedgerName: obj[0].ledgerName,
                BankID: 0,
                BranchCode: obj[0].branch,
                BudgetAmt: 0,
                CloBal: obj[0].openingBal,
                CrAmt: "0",
                DbAmt: "0",
                HeadID: obj[0].headID,
                IFSCCode: obj[0].IFSC,
                IsBank: obj[0].isBank,
                IsCustomer: obj[0].isCustomer,
                IsFav: false,
                IsSupplier: obj[0].isSupplier,
                LdrOpeningBal: obj[0].openingBal,
                LedgerType: head[0].LedgerType,
                LevelPath: head[0].LevelPath,
                MICRCode: '',
                OpBal: obj[0].openingBal,
                Policy: 0,
                RelAgencyID: obj[0].relAgencyID,
                RelID: obj[0].relID
            });

            this.sendChanges(obj, 2, 'set');
        }
    }

    sendChanges(obj: any, moduleId: number, actionType: string) {
        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: actionType,
            moduleID: moduleId,
            data: JSON.stringify(obj)
        }];

        this.apiService.sendChange(myParams, this.successGroupEntry.bind(this), this.failureResp.bind(this));
        if (this.modalReference) {
            this.modalReference.close();
        }

        // if (moduleId == 1 && actionType == 'edit') {
        //     this.tree[this.tree.length - 1].headName = this.newGroup.newGroupName
        // }

        // this.resetNewGroup();
        this.resetNewLedger();

    }

    successGroupEntry(res: any) {
        if (res.error) {
            alert(res.message);
            this.newledgerEntryData = [];
        }
        else {
            this.getData();
            this.removeCookie("LdgrsForVhcr");
            alert(res.message);
            this.getBankData();
        }
    }

    removeCookie(cName: string) {
        if (cName) {
          localStorage.removeItem(cName);
        }
      }

    printVoucher() {
        var VID = this.voucherID;
        //window.open('voucherPrint?VID=' + VID, '_blank', 'location=yes,height=1000,width=700,scrollbars=yes,status=yes');
        window.open('voucherPrint?VID=' + VID, '_blank', 'Height= 900px, Width= 900px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
        //this.router.navigateByUrl('voucherPrint?VID=' + VID);
    }

    printVoucherHistory(vHID: any){
        var VID = this.voucherID;
        window.open('voucherPrint?VID=' + VID + '&VHID=' + vHID, '_blank', 'Height= 900px, Width= 900px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
    }

    printVoucherReceipt() {
        var VID = this.voucherID;
        window.open('paymentReceipt?VID=' + VID, '_blank','Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');  
    }

    //deleteVoucher
    deleteVoucherOpenPopup(voucherID: any) {
    if (confirm("Are you sure you wish to delete this voucher?")) {
      var tempData = [{
        'voucherID': voucherID
      }]

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'delete',
        moduleID: 0,
        data: JSON.stringify(tempData)
      }];

      this.apiService.sendChange(myParams, this.successVchrDelete.bind(this), this.failureRespVchrDelete.bind(this));
    }
  }

  //successVchrDelete 
  successVchrDelete(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
      this.window.isSuccessVoucher = 1;
    }
  }

  //failureResp - failure handler
  failureRespVchrDelete(res: any) {
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //openDocsPrint() - Docs Print Open
  openDocsPrint(){

    if(this.docDetails.DocID > 0){
        let isQuote: boolean = false;
        if (this.docDetails.DocType == "DQOT") {
            isQuote = true;
        }

        let tmpType = '';
        if (this.docDetails.DocType == 'DPI') {
            tmpType = "DQOT";
        }
        else {
            tmpType = this.docDetails.DocType;
        }

        let stringDATA = [{
            strURL: "isSupplier=0&isIncludeHeader=1&isIncludeAddr=0&isIncludeDigital=0&IsAgencyHasHeader=1&ID=" + this.docDetails.DocID  + "&isPDF=0" + "&AID=" + this.jarvisData[0].AgencyIDs + "&type=" + tmpType + "&isQuote=" + (isQuote ? 1 : 0)
        }];

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'encrypt',
            moduleID: 13,
            data: JSON.stringify(stringDATA)
        }];
        this.apiService.getData(myParams, this.successDocPrint.bind(this), this.failureResp.bind(this));
    }
  }

  successDocPrint(res: any) {
    if (res.error) {
        alert(res.message);
    }
    else {
        let tmpData: any = JSON.parse(res.updatePackage);
        let encryptedLink = tmpData.Table[0].Link;
        console.log(encryptedLink);

        var url = "";
        if (this.apiService.fn_isLiveURL() == true) {
            url = "https://biziverse.com/Html/Pages/PrtDoc.html?" + encryptedLink;
        }
        else{
            url = "http://localhost:60228/Html/Pages/PrtDoc.html?" + encryptedLink;
        }

        window.open(url, "#1", "height= 600px, width=920px, top= 100px, left=200px, edge= Raised, center= Yes, help= No, resizable= No, status= No, scrollbars =1 ");
        
    }
}

  // getBankData() - get all getBankData databse
  getBankData(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successRespBankData.bind(this), this.failureRespBankData.bind(this));
    }

     //successResp - success  get handler
     successRespBankData(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                let tempData: any = [];
                console.log('bank data', reponseData);
                tempData = reponseData.Table2[0].BankLedgers;
               let bankList = this.apiService.getCookie('ERP_Cfg');
               if (bankList) {
                 bankList = JSON.parse(bankList);
                 let bankUpdatedData: any = [];  
                bankUpdatedData = bankList; 
                 if (bankUpdatedData.length > 0) {
                  bankUpdatedData[0].BankLedgers = tempData;
                 }
                 this.apiService.setCookie('ERP_Cfg', JSON.stringify(bankUpdatedData));
               }
             }
          }
      }
  }

  //failureResp - failure handler
  failureRespBankData(res: any) {
    if (res.error) {
    }
}

    changeRecvry(){
        // Change for Update Recovery Amount       
        if(this.data.isUpdateRecAmt == true) {
            this.custLdrCnt = 0;
            this.rcvdAmt = 0
            this.data.recAmt = 0;            
            for(let i: number = 0; i < this.dataTbl.length; i++){
                if(this.dataTbl[i].credit > 0){
                    let selectedLdr = this.ledgers.filter((o: any) => o.IsCustomer == true && o.LedgerID == this.dataTbl[i].ledgerID);
                    if(selectedLdr.length > 0){
                        this.custLdrCnt = this.custLdrCnt + 1;
                        if(this.custLdrCnt == 1){
                            this.isShowUpdateRecovery = true;
                            this.data.isUpdateRecAmt = true;
                            this.rcvdAmt = this.dataTbl[i].credit;
                            this.data.relID = selectedLdr[0].RelID;
                            this.getRelDetails(this.data.relID);
                            
                            /*let cloVal: number = Number(String(selectedLdr[0].CurrentBal).replaceAll(",", ""));
                            this.data.recAmt =  cloVal - Number(this.dataTbl[i].credit);
                            if(this.data.recAmt < 0){
                                this.data.recAmt = 0;
                            }*/
                        }
                        else{
                            this.data.isUpdateRecAmt = false;
                            this.isShowUpdateRecovery = false;
                            this.data.recAmt = 0;
                            this.data.relID = 0;
                        }
                    }
                }
            }
        } 
        else {
            this.data.recAmt = 0;
            this.rcvdAmt = 0
        }
    }

    openVoucherHistory(content: any) {
        this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'dateFilter', backdrop: 'static', keyboard: false });
        this.modalReference.result.then((result: any) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason: any) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }

      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return `with: ${reason}`;
        }
      }

      public closeModal($event: any) {
          this.modalReference.close();
      }

       // color change 
  changeColor(ind: any){
    var clr = ""
    switch(ind) { 

      case 0: { 
        clr = 'orangeBadge'
         break; 
      } 
      case 1: {
        clr = 'yellowBadge'
        break; 
      } 
      case 2: { 
        clr = 'greenBadge'
         break; 
      } 
      case 3: { 
        clr = 'tealBadge'
         break; 
      } 
      case 4: { 
        clr = 'blueBadge'
         break; 
      } 
      case 5: { 
        clr = 'darkBlueBadge'
         break; 
      } 
      case 6: { 
        clr = 'brownBadge'
         break; 
      } 
    
   }
   return clr; 
  }

  // Open Help Page
  openHelpPage(id: any) {
    this.commonService.openModulHelp(id, this.isWeb);
  }
  
  onFocusEvent(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    if (input.value === '0' || input.value === '0.00') {
      input.value = ''; // Clear the value
    }
  }

  //getRelDetails() - Get relative data
  getRelDetails(relID: any) {
    if (!relID) {
        return;
    }

    let data = [{
        relativeid: relID
    }]

    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: this.apiService.getCookie("MyLastSyncDT"),
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getRelDetails',
        moduleID: 902,
        data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successRelData.bind(this), this.failureRelData.bind(this));

}

  //successResp - success  get handler
  successRelData(res: any) {
      if (res.error) {
          console.log(res.message);
      } else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData) {
                    let cstrRcvbl = reponseData.Table1[0].Receivable ? reponseData.Table1[0].Receivable : this.data.recAmt;    
                    this.data.recAmt =  cstrRcvbl - Number(this.rcvdAmt);
                    if(this.data.recAmt < 0){
                        this.data.recAmt = 0;
                    }          
              }
          }
      }
  }

//failureResp - failure handler
failureRelData(res: any) {
    if (res.error) {
        console.log(res.message);
    } else {
        this.apiService.successAlert(res.message);
    }
}

}

declare global {
    interface Date {
        customFormat(formatString: any): string;
    }
}



// String Prototye
Date.prototype.customFormat = function (formatString: any) {
    var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
    YY = ((YYYY = this.getFullYear()) + "").slice(-2);
    MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
    MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
    DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
    DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
    th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
    formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
    h = (hhh = this.getHours());
    if (h == 0) h = 24;
    if (h > 12) h -= 12;
    hh = h < 10 ? ('0' + h) : h;
    hhhh = h < 10 ? ('0' + hhh) : hhh;
    AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
    mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
    ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
    return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}
